import { IconButton } from '@mui/material';
import Icon from '@src/main/ui/components/common/Icon/Icon';
import { FC } from 'react';

interface Props {
  onClick: () => void;
}

const CloseButton: FC<Props> = ({ onClick }) => (
  <IconButton onClick={onClick} sx={{ fontSize: '12px' }}>
    <Icon iconId="close" />
  </IconButton>
);

export default CloseButton;
